'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'

import { useMobileNavigation } from '@maestro/commerce-blocks/providers/mobile-navigation/context'
import { useBreakpoint } from '@pearlconvert/ui/providers/breakpoint/breakpoint.context'

export const useNavigationHeaderFoldout = () => {
  const { closeMenu, isOpen } = useMobileNavigation()
  const { isDesktopView } = useBreakpoint()
  const pathname = usePathname()

  const lastPathname = useRef(pathname)
  useEffect(() => {
    if (lastPathname.current !== pathname) {
      lastPathname.current = pathname
      if (isOpen) {
        closeMenu()
      }
    }
  }, [pathname, isOpen, closeMenu])

  return {
    closeMenu,
    isOpen,
    isDesktop: isDesktopView(),
  }
}
